var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"node-operate-wrapper"},[_c('span',[_c('i',{staticClass:"el-icon-edit-outline",on:{"click":_vm.openEdit}})]),_c('span',[_c('i',{staticClass:"el-icon-delete",on:{"click":_vm.deleteNode}})])])}
var staticRenderFns = []

export { render, staticRenderFns }